export enum Features {
    AUTO_REPLENISH = 'autoReplenish',
    BENEFIT = 'benefit',
    BRAND = 'brand',
    COLOR_FAMILY = 'colorFamily',
    DESCRIPTION_STATEMENTS = 'descriptionStatements',
    DISCOUNTS = 'discounts',
    ENGRAVING = 'engraving',
    EXCLUDE_TAX = 'excludeTax',
    FAVORITES = 'favorites',
    FINISH_OPTIONS = 'finishOptions',
    FINISH = 'finish',
    FORM = 'form',
    FREE_FROM = 'freeFrom',
    FRAGRANCE_FAMILY = 'fragranceFamily',
    FRAGRANCE_NOTES = 'fragranceNotes',
    KEY_INGREDIENTS = 'keyIngredients',
    KEY_INGREDIENTS_COLLECTION = 'keyIngredientsCollection',
    LIMITED_REMAINING = 'limitedRemaining',
    LOCATION = 'location',
    MAINCAT = 'maincat',
    MOOD = 'mood',
    OCCASION = 'occasion',
    OCCASION_PRODUCT = 'occasionProduct',
    PERLGEM = 'perlgem',
    PREORDER = 'preOrder',
    PRODUCT_LARGE_IMAGES = 'productLargeImages',
    PRODUCT_MEDIUM_IMAGES = 'productMediumImages',
    PRODUCT_SMALL_IMAGES = 'productSmallImages',
    PRODUCT_BADGE_IMAGE = 'productBadgeImage',
    PRODUCT_COLLECTION = 'productCollection',
    PRODUCT_COVERAGE = 'productCoverage',
    PRODUCT_CROSS_SELL = 'productCrossSell',
    PRODUCT_FINISH = 'productFinish',
    PRODUCT_REVIEW = 'productReview',
    PRODUCT_SKIN_TYPE = 'productSkinType',
    PRODUCT_VIDEOS = 'productVideos',
    RECIPIENT = 'recipient',
    REVIEWS_NUMBER_OF_QUESTIONS = 'reviewsNumberOfQuestions',
    SHADE_GROUPS = 'shadeGroups',
    SKU_MAINCAT = 'skuMaincat',
    SKU_SKIN = 'skuSkin',
    SKIN_TONE = 'skinTone',
    SKIN_TYPE = 'skinType',
    SKIN_CONCERN = 'skinConcern',
    SKIN_GOAL = 'skinGoal',
    SKU_COLLECTION = 'skuCollection',
    SKU_URL = 'skuUrl',
    SKU_LARGE_IMAGES = 'skuLargeImages',
    SKU_MEDIUM_IMAGES = 'skuMediumImages',
    SKU_SMALL_IMAGES = 'skuSmallImages',
    SKU_SMOOSH_IMAGES = 'skuSmooshImages',
    SKU_MODEL_IMAGES = 'skuModelImages',
    SKU_BADGE_IMAGE = 'skuBadgeImage',
    SMARTGIFT = 'smartGift',
    STYLE = 'style',
    SUBCAT = 'subcat',
    SUB_DISPLAY_NAME = 'subDisplayName',
    SUB_HEADER = 'subHeader',
    TEXTURE = 'texture',
    UNDERTONE = 'undertone',
    USAGE = 'usage',
    VTO_FOUNDATION = 'vtoFoundation',
    VTO_MAKEUP = 'vtoMakeup',
    VTO_CROSS_SELL = 'vtoCrossSell',
    SHADE_IMAGE = 'shadeImage',
    USAGE_OPTIONS = 'usageOptions',
    FORMULATED_WITHOUT = 'formulatedWithout',
    SKU_TAGS = 'skuTags'
}

export enum FavoritesState {
    ON = 'on',
    OFF = 'off'
}

export interface IFeature {
    enabled: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}

export type IFeatures = {
    [key in Features]: IFeature;
};
